import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[large-device]'
})
export class LargeDeviceDirective implements OnInit {
  @Input()
  public breakpoint: number
  constructor(private el: ElementRef) { }

  defaultWidth = window.innerWidth;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.switchView(event.target.innerWidth);
  }

  private switchView(width: number) {
    if (width > this.breakpoint) {
    this.el.nativeElement.style.display = 'block';
  }
  else{
      this.el.nativeElement.style.display = 'none';
    }
  }

  ngOnInit(): void {
    this.switchView(this.defaultWidth);
  }

}
